import React from 'react';
import { FieldError } from 'react-hook-form';
import { Label } from '../ui/label';
import type { Form } from '../../interfaces/form.interface';
import type { Metadata } from '../../interfaces/metadata.interface';
import { renderRichText } from '../../utils/rich-text';

interface BaseFieldProps {
  meta: Metadata;
  label?: boolean;
  index: number;
  error?: FieldError;
  configuration: Form;
  children: React.ReactNode;
}

export const BaseField: React.FC<BaseFieldProps> = ({
  meta,
  index,
  error,
  configuration,
  children,
  label = true
}) => {
  return (
    <div className="space-y-2">
      {meta.definition?.description && (
        <p className="font-semibold text-sm">
          <strong>{renderRichText(meta.definition.description)}</strong>
        </p>
      )}
      
      <div className="space-y-3">
        {label && (
        <Label htmlFor={meta.id} className="text-sm font-medium block mb-2">
          <span style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
            {index + 1}. {meta.name}
          </span>
          {meta.mandatory && <span className="text-red-500 ml-1">*</span>}
        </Label>
        )}

        {children}

        {error && (
          <p className="text-red-500 text-sm">
            {error.message}
          </p>
        )}
      </div>
    </div>
  );
}; 